import React, { useState, useEffect } from "react"
import { Link } from "gatsby"
import { Container } from "react-bootstrap"
import GetLink from "../functions/GetLink"
import GlobalFormModal from "../PopUpForm/PopUpForm"
import "./DownloadGuide.scss"

const DownloadGuide = ({ module, pageTitle }) => {
  const [show, setShow] = useState(false)
  const closeGlobalForm = () => {
    setShow(false)
  }
  return (
    <>
    <div className="download-guide-wrapper">
      <div className="download-guide-container rounded">
        <div className="content-section">
          <h3 className="title">{module.Download_Guide_Title}</h3>
          <p className="description">{module.Download_Guide_Text}</p>
        </div>
        <div className="cta-section">
          {module.CTA_Link ? (
            <GetLink
              link={module.CTA_Link}
              label={module.CTA_Label}
              className="cta-text cta"
            />
          ) : module.CTA_Secondary_Link == "#globalpopupform" ? (
            <a href="javascript:void(0)" onClick={() => { setShow(true) }} className="cta-text cta">
              {module.CTA_Label}
            </a>
          ) : module.CTA_Secondary_Link ? (
            <Link to={module.CTA_Secondary_Link} className="cta-text cta" state={{ pageTitle: pageTitle, file_url: module?.Upload_Guide?.url }}>
              {module.CTA_Label}
            </Link>
          ) : (
            module.Upload_Guide && (
              <a
                href={module?.Upload_Guide?.url}
                target="_blank"
                className="cta-text cta"
              >
                {module.CTA_Label}
              </a>
            )
          )}
        </div>
      </div>
      <GlobalFormModal showGlobalForm={show} closeGlobalForm={closeGlobalForm} />
    </div>
    <div className="container">
      <p>Page last update: {module.Updated_Guide_Date}</p>
      <p>&nbsp;</p>
    </div>
    </>
  )
}

export default DownloadGuide
